<template>
    <div id="innercontainer" style="width:98%;height:100%;margin:0 auto">


        <div id="ResearchProjects" align="left" >
            <p style="font-size:23px;margin-top:10px;">Datasets</p>
            <div id="Project1">
                <a-space direction="vertical">
                    <a-typography-link style="font-size:20px;margin-top:-10px;" href="https://philjohnrose.net/Wu_tones/Wu_citation_tones/Wu_sites_ZJ_JS.html" target="_blank">
                        <right-outlined></right-outlined>
                        [Item#:002] Wu tone map
                    </a-typography-link>
                    <a-typography-text strong style="font-size: 15px">From October 2021 - March 2022</a-typography-text>
                </a-space>
                <p style="font-size:17px; margin-top: 10px">
                    These are some good stuff Phil has been working on. The current database contains 
                    recordings across 140 Chinese Wu sites from thousands of local speakers. I offered him fieldwork recordings in
                    six Wu sites (some at the putative boundary of left and right dominant tone sandhi speaking places).
                    They are Jinshan and Songjiang in Shanghai, and Huzhou, Zhuji, Shengzhou and Shangyu in Zhejiang.
                </p>
            </div>

        </div>

        <a-divider/>
         <div id="Project_final" align="left">
                <p style="font-size:20px; margin-top: -10px; font-Weight:bold;">
                    For details of my finished projects, please click on the paper section.
                </p>
            </div>
    </div>
</template>

<script>
    import { RightOutlined } from '@ant-design/icons-vue';
    export default {
        name: 'HomeComponent',
        methods:{

        },
        components: {
            RightOutlined,
        },
    }
</script>